<template>
    <div class="dailylistbox">
              <ul class="meitianul">

                <li v-for="(item,index) in hotpicklist" :key="index" @mouseenter="handlephMouseEnter(item.id)"   @mouseleave="handlephMouseLeave(item.id)" @click="goosid02(item.osid)">

                  <div class="photcover" v-if="showhotcover && item.id==dqphid"><div class="phshiyongbtn">使用</div></div>

                  <div class="alimgbox">
                     
                     <img :src="item.bigpic[0]==='/' ? 'https://api.pkzoo.com'+item.bigpic : 'https://api.pkzoo.com/'+item.bigpic " />
                    <!-- <el-avatar shape="square" style="width: 300px;height: 300px;"  :fit="contain" :src="item.bigpic"></el-avatar> -->
                  </div>
                  <div class="alimgname">
                    <dl>
                      <dt>
                        <img :src="item.oslogo[0]==='/' ? 'https://api.pkzoo.com'+item.oslogo : 'https://api.pkzoo.com/'+item.oslogo" />
                      </dt>
                      <dd>
                        <h5>{{ item.osname }}</h5>
                        <p>{{ item.osprofile }}</p>
                      </dd>
                    </dl>
                  </div>
                </li>
              </ul>
            </div>
</template>

<script>
import { getmainclass,getsubclassselectos,getselectmainhotpick,getappdetail } from "@/api/api";
    export default {
        props:["hotpicklist"],
        data() {
            return {
                blogo02: require("@/assets/images/b-icon_002.jpg"),
                ismore:false,
                showhotcover:false,
                dqphid:""
            }
        },
        methods: {
            handlephMouseEnter(id){
                this.dqphid = id;
                this.showhotcover = true;
                },
            handlephMouseLeave(){
                this.dqphid = "";
                this.showhotcover = false;
            },

            goosid02(id){
              
                getappdetail(id).then(res=>{
                    console.log('res',res);
                    var width = 1380;
                    const height = 900
                    // 计算居中位置
                    const left = (window.screen.width - width) / 2;
                    const top = (window.screen.height - height) / 2 - 50;

                    

                    var osurl = res.data.rows[0].osurl;
                    console.log('osurl',osurl);
                    window.open (osurl, 'newwindow', `width=${width},height=${height},left=${left},top=${top}, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no`) 
        //写成一行 
                    //this.ositemlist = res.data.oslist;
                })

   },  
            gomore(){
                this.ismore = !this.ismore;

            }  
        },
    }
</script>

<style lang="scss" scoped>

ul.meitianul li {
      float: left;
      width: 19%;
      max-width: 355px;
      margin-right: 10px; cursor: pointer; position: relative;

      .photcover{ position: absolute; left: 0; top: 0; width: 100%; height: 100%; background:rgba(0,0,0,0.3);}

      .phshiyongbtn{
        display:line-block; text-align: center; z-index: 5;  left: 45%; top:40%; width: 50px; height: 30px; position: absolute; color: #fff; border-radius: 20px; background: rgba(39,196,47,0.8) !important; line-height: 30px; padding: 0 !important;
      }
    }


.dailylistbox {
        overflow: hidden;
        .alimgbox { 
            max-height: 180px; overflow: hidden;
          img {
            
            width: 100%;
          }
        }
        .alimgname {
          padding-top: 8px;
          dl {
            display: flex; justify-content: left; align-items: center;
            dt {
              
              min-width: 50px; width: 50px;
              img {
                border-radius: 50%;
                width: 100%;
                margin-top: 8px;
              }
            }

            dd {
              margin-left: 10px;
              width: 80%;
              h5 {
                font-size: 15px;
                color: #333;
              }
              p {
                color: #999;
                overflow: hidden;
                text-overflow: ellipsis;
                /*-webkit-text-overflow:ellipsis;*/
                white-space: nowrap;
              }
            }

            @media screen and (max-width: 1380px) {
              /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
              dd {
                float: left;
                width: 70%;
                h5 {
                  font-size: 15px;
                  font-weight: normal;
                  color: #333;
                }
                p {
                  color: #999;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  /*-webkit-text-overflow:ellipsis;*/
                  white-space: nowrap;
                }
              }
            }
          }
        }
      }


</style>


// WEBPACK FOOTER //
// src/components/publish/hotpick.vue